<div ngModelGroup="ciInputInputs">
  <div class="form-group row">
    <!-- Add button -->
    <div id="addBtn" class="col-12">
      <button
        *ngIf="!isReadOnly"
        type="button"
        title="{{'CommercialImpactInputs.AddCommercialImpactInput' | i18next}}"
        (click)="addCommercialImpactInput()"
        class="add-btn-alt float-right"
      >
        <i class="fas fa-plus-circle action-icon"></i>
      </button>
    </div>

    <div id="dataTable" class="col-md-12 data-display-table">
      <!-- Main Table -->
      <p-table [value]="getCommercialImpactInputs()">
        <!-- Column Headers -->
        <ng-template pTemplate="header" let-columns>
          <tr id="headerRow">
            <th scope="col">{{'CommercialImpactInputs.Description' | i18next}}</th>
            <th scope="col" *ngIf="isProductionTable">{{'CommercialImpactInputs.Impact' | i18next}}</th>
            <th scope="col">{{'CommercialImpactInputs.Quantity' | i18next}}</th>
            <th scope="col" *ngIf="isProductionTable">{{'CommercialImpactInputs.CostHour' | i18next}}</th>
            <th scope="col" *ngIf="isProductionTable">{{'CommercialImpactInputs.ValueUnit' | i18next}}</th>
            <th scope="col" *ngIf="!isProductionTable">{{'CommercialImpactInputs.ValueHour' | i18next}}</th>
            <th scope="col">{{'CommercialImpactInputs.TotalCost' | i18next}}</th>
            <!-- Used for the trash can icon -->
            <th scope="col" *ngIf="!isReadOnly" id="trashCol"></th>
          </tr>
        </ng-template>

        <!-- Data Rows -->
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <!-- Description -->
            <td>
              <p-cellEditor *ngIf="!isReadOnly" pEditableColumn>
                <!-- Editing display -->
                <ng-template pTemplate="input">
                  <!-- Input field -->
                  <input
                    name="description{{ rowIndex }}"
                    type="text"
                    [(ngModel)]="rowData.description"
                    #description="ngModel"
                    class="form-control"
                    required
                  />
                  <!-- Validation error message -->
                  <p *ngIf="form.submitted && description.invalid" class="primeng-invalid-feedback word-wrap">
                    {{'CommercialImpactInputs.DescriptionValueIsRequired' | i18next}}
                  </p>
                </ng-template>
                <!-- Non-editing display -->
                <ng-template pTemplate="output">
                  {{ rowData.description }}
                </ng-template>
              </p-cellEditor>
              <div *ngIf="isReadOnly">
                {{ rowData.description }}
              </div>
            </td>

            <!-- Impact Percentage -->
            <td *ngIf="isProductionTable">
              <p-cellEditor *ngIf="!isReadOnly" pEditableColumn>
                <ng-template pTemplate="input">
                  <input
                    name="impact{{ rowIndex }}"
                    type="number"
                    [(ngModel)]="rowData.impact"
                    hbRange
                    min="0"
                    max="100"
                    minInclusive="true"
                    maxInclusive="true"
                    #impact="ngModel"
                    class="form-control"
                    required
                  />
                  <span *ngIf="form.submitted && (impact.errors?.range || impact.errors?.required)" class="primeng-invalid-feedback word-wrap">
                    {{'CommercialImpactInputs.ImpactMustBeValidPercentageValue' | i18next}}
                  </span>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ rowData.impact }}
                </ng-template>
              </p-cellEditor>
              <div *ngIf="isReadOnly">
                {{ rowData.impact }}
              </div>
            </td>

            <!-- Quantity -->
            <td>
              <p-cellEditor *ngIf="!isReadOnly" pEditableColumn>
                <ng-template pTemplate="input">
                  <input
                    name="quantity{{ rowIndex }}"
                    type="number"
                    hbRange
                    min="0"
                    minInclusive="true"
                    [(ngModel)]="rowData.quantity"
                    #quantity="ngModel"
                    class="form-control"
                    required
                  />
                  <span *ngIf="form.submitted && (quantity.errors?.range || quantity.errors?.required)" class="primeng-invalid-feedback word-wrap">
                    {{'CommercialImpactInputs.ValueMustBeGreaterThanOrEqualTo0' | i18next}}
                  </span>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ rowData.quantity }}
                </ng-template>
              </p-cellEditor>
              <div *ngIf="isReadOnly">
                {{ rowData.quantity }}
              </div>
            </td>

            <!-- Units per Hour -->
            <td *ngIf="isProductionTable">
              <p-cellEditor *ngIf="!isReadOnly" pEditableColumn>
                <ng-template pTemplate="input">
                  <input
                    name="unitsPerHour{{ rowIndex }}"
                    type="number"
                    hbRange
                    min="0"
                    minInclusive="true"
                    [(ngModel)]="rowData.unitsPerHour"
                    #unitsPerHour="ngModel"
                    class="form-control"
                    required
                  />
                  <span
                    *ngIf="form.submitted && (unitsPerHour.errors?.range || unitsPerHour.errors?.required)"
                    class="primeng-invalid-feedback word-wrap"
                  >
                    {{'CommercialImpactInputs.ValueMustBeGreaterThanOrEqualTo0' | i18next}}
                  </span>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ rowData.unitsPerHour }}
                </ng-template>
              </p-cellEditor>
              <div *ngIf="isReadOnly">
                {{ rowData.unitsPerHour }}
              </div>
            </td>

            <!-- Value per Unit -->
            <td *ngIf="isProductionTable">
              <p-cellEditor *ngIf="!isReadOnly" pEditableColumn>
                <ng-template pTemplate="input">
                  <input
                    name="valuePerUnit{{ rowIndex }}"
                    type="number"
                    hbRange
                    min="0"
                    minInclusive="true"
                    [(ngModel)]="rowData.valuePerUnit"
                    #valuePerUnit="ngModel"
                    class="form-control"
                    required
                  />
                  <span
                    *ngIf="form.submitted && (valuePerUnit.errors?.range || valuePerUnit.errors?.required)"
                    class="primeng-invalid-feedback word-wrap"
                  >
                    {{'CommercialImpactInputs.ValueMustBeGreaterThanOrEqualTo0' | i18next}}
                  </span>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ rowData.valuePerUnit }}
                </ng-template>
              </p-cellEditor>
              <div *ngIf="isReadOnly">
                {{ rowData.valuePerUnit }}
              </div>
            </td>

            <!-- Value per Hour -->
            <td *ngIf="!isProductionTable">
              <p-cellEditor *ngIf="!isReadOnly" pEditableColumn>
                <ng-template pTemplate="input">
                  <input
                    name="valuePerHour{{ rowIndex }}"
                    type="number"
                    hbRange
                    min="0"
                    minInclusive="true"
                    [(ngModel)]="rowData.valuePerHour"
                    #valuePerHour="ngModel"
                    class="form-control"
                    required
                  />
                  <span
                    *ngIf="form.submitted && (valuePerHour.errors?.range || valuePerHour.errors?.required)"
                    class="primeng-invalid-feedback word-wrap"
                  >
                    {{'CommercialImpactInputs.ValueMustBeGreaterThanOrEqualTo0' | i18next}}
                  </span>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ rowData.valuePerHour }}
                </ng-template>
              </p-cellEditor>
              <div *ngIf="isReadOnly">
                {{ rowData.valuePerHour }}
              </div>
            </td>

            <!-- Total Cost (readonly) -->
            <td>
              <div *ngIf="!isReadOnly">
                {{ calculateCurrentInputTotal(rowIndex) }}
              </div>
              <div *ngIf="isReadOnly">
                {{ rowData.totalCost }}
              </div>
            </td>

            <!-- Delete Row -->
            <td *ngIf="!isReadOnly">
              <a (click)="deleteCommercialImpactInput(rowIndex)" title="{{'CommercialImpactInputs.DeleteActivity' | i18next}}">
                <i class="fa fa-trash pointer"></i>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
